import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import { DefaultShortcutState } from '../reducers/shortcutById_reducer'
import {
  fetchShortcutIfNeeded,
  setShortcutAudiencePreference,
  setOverrideAccessToken
} from '../actions'

import Spinner from '../components/Spinner'
import ExpiredShortcut from '../components/ExpiredShortcut'
import NotFound from '../components/NotFound'

import HomepageContainer from './homepage/HomepageContainer'
import TrackerContainer from './tracker/TrackerContainer'
import AudienceContainer from './audience/AudienceContainer'
import AudienceAcquisitionContainer from './acquisition/AudienceAcquisitionContainer'
import UMapExplorerContainer from './umap/UMapExplorerContainer'
import RediscoverContainer from './rediscover/RediscoverContainer'
import SubscriberContainer from './subscriber/SubscriberContainer'
import AttentionContainer from './attention/AttentionContainer'
import FaqComponent from '../components/faq/FaqComponent'
import { HOME_PAGE, ENTITY, VIDEO_CHANNEL, AUDIENCE_ACQUISITION_MODULE, COMPARE, TRACKER_MODULE, BL, DISCOVER, REDISCOVER, DISCOVER_EXPLORE, SUBSCRIBER, AUDIENCE_LIFT_MODULE, ATTENTION_INDEX_MODULE, BUDGET_SUBSCRIBERS_MODULE, FAQ_MODULE, CALENDAR_MODULE, MEDIA_PLANNING_SHORTCUT, ATTENTION_INDEX_NEW, TRENDING_TOPICS_BL } from '../constants/commons'
import { CHAT_BOTS } from '../constants/chat_bot'
import GoogleAnalytics from '../classes/GoogleAnalytics'
import BudgetSubscribersContainer from './budgetsubscribers/BudgetSubscribersContainer'
import DashboardContainer from './dashboard/DashboardContainer'
import { SOV_DISTRIBUTION, SOV_MEDIA_COMPANY, SOV_STREAMING } from '../constants/sov'
import CalendarContainer from './calendar/CalendarContainer'
import GlobalAttentionContainer from './globalattention/GlobalAttentionContainer'
import ChatBotContainer from './aiinsights/ChatBotContainer'
import TrendingContainer from './trending/TrendingContainer'

class ShortcutContainer extends React.Component {
  static propTypes = {
    isAdmin: PropTypes.bool.isRequired,
    shortcut: PropTypes.shape({
      isFetching: PropTypes.bool,
      details: PropTypes.object,
      error: PropTypes.object,
      preference: PropTypes.string
    }),
    fetchShortcut: PropTypes.func.isRequired,
    setPreference: PropTypes.func,
    setAuth: PropTypes.func.isRequired,
    location: PropTypes.object.isRequired
  }

  componentDidMount () {
    GoogleAnalytics.trackGA(BL, this.props.location)
    this.props.fetchShortcut()
    this.props.setAuth()
  }

  componentDidUpdate (prevProps) {
    if (prevProps.shortcut.details != this.props.shortcut.details) {
      this.props.fetchShortcut()
      this.props.setAuth()
    }
  }

  render () {
    if (this.props.shortcut.error || (this.props.shortcut.details && (this.props.shortcut.details.target === COMPARE))) {
      return (<NotFound isAdmin={this.props.isAdmin}/>)
    }
    if (this.props.shortcut.isFetching) {
      return (<Spinner />)
    }
    if (Date.parse(this.props.shortcut.details.expires_at) < new Date()) {
      return (<ExpiredShortcut />)
    }
    const s = this.props.shortcut.details
    return (
      <>
        { s.target === HOME_PAGE &&
          <HomepageContainer shortcut={s} location={this.props.location} shortcutPreference={this.props.shortcut.preference}/>
        }
        { s.target === TRACKER_MODULE &&
          <TrackerContainer shortcut={s} location={this.props.location} shortcutPreference={this.props.shortcut.preference}/>
        }
        { (s.target === AUDIENCE_ACQUISITION_MODULE || s.target === AUDIENCE_LIFT_MODULE) &&
          <AudienceAcquisitionContainer
            shortcut={s}
            location={this.props.location}
            shortcutPreference={this.props.shortcut.preference}
            setShortcutPreference={this.props.setPreference}/>
        }
        { (s.target === ENTITY || s.target === VIDEO_CHANNEL || s.target === MEDIA_PLANNING_SHORTCUT) &&
          <AudienceContainer
            shortcut={s}
            shortcutPreference={this.props.shortcut.preference}
            setShortcutPreference={this.props.setPreference}
            location={this.props.location}
            />
        }
        { (s.target === DISCOVER && this.props.shortcut.preference === DISCOVER_EXPLORE ||
          (s.target === DISCOVER && !s.target_id && (this.props.shortcut.preference === REDISCOVER || this.props.shortcut.preference !== REDISCOVER))) &&
          <UMapExplorerContainer
            shortcut={s}
            location={this.props.location}
            shortcutPreference={this.props.shortcut.preference}
            setShortcutPreference={this.props.setPreference}
          />
        }
        { (s.target === DISCOVER && s.target_id && (this.props.shortcut.preference === REDISCOVER || this.props.shortcut.preference !== DISCOVER_EXPLORE)) &&
          <RediscoverContainer
            shortcut={s}
            location={this.props.location}
            shortcutPreference={this.props.shortcut.preference}
            setShortcutPreference={this.props.setPreference}
          />
        }
        { s.target === SUBSCRIBER &&
          <SubscriberContainer
            shortcut={s}
            location={this.props.location}
            shortcutPreference={this.props.shortcut.preference}/>
        }
        { s.target === ATTENTION_INDEX_MODULE &&
          <AttentionContainer
            shortcut={s}
            location={this.props.location}
            shortcutPreference={this.props.shortcut.preference}/>
        }
        { s.target === BUDGET_SUBSCRIBERS_MODULE &&
          <BudgetSubscribersContainer
            shortcut={s}
            location={this.props.location}
            shortcutPreference={this.props.shortcut.preference}/>
        }
        { s.target === BUDGET_SUBSCRIBERS_MODULE &&
          <BudgetSubscribersContainer
            shortcut={s}
            location={this.props.location}
            shortcutPreference={this.props.shortcut.preference}/>
        }
        { (s.target === SOV_STREAMING || s.target === SOV_DISTRIBUTION || s.target === SOV_MEDIA_COMPANY) &&
          <DashboardContainer
            shortcut={s}
            location={this.props.location}
            shortcutPreference={this.props.shortcut.preference}/>
        }
        { s.target === FAQ_MODULE &&
          <FaqComponent
            shortcut={s}/>
        }
        { s.target === CALENDAR_MODULE &&
          <CalendarContainer
            shortcut={s}
            location={this.props.location}
            shortcutPreference={this.props.shortcut.preference}/>
        }
        { s.target === ATTENTION_INDEX_NEW &&
          <GlobalAttentionContainer
            shortcut={s}
            location={this.props.location}
            shortcutPreference={this.props.shortcut.preference}/>
        }
        { (CHAT_BOTS.filter(e => e.botValue === s.target).length > 0) &&
          <ChatBotContainer
            shortcut={s}
            location={this.props.location}
            shortcutPreference={this.props.shortcut.preference}/>
        }
        { s.target === TRENDING_TOPICS_BL &&
          <TrendingContainer
            shortcut={s}
            location={this.props.location}
            shortcutPreference={this.props.shortcut.preference}/>
        }
      </>
    )
  }
}

function mapStateToProps (state, ownProps) {
  const isAdmin = state.user.isAdmin
  const shortcutId = ownProps.match.params.shortcutId
  const shortcutState = state.shortcuts.byId[shortcutId] || DefaultShortcutState
  const location = ownProps.location
  const shortcut = {
    isFetching: shortcutState.isFetching || shortcutState.didInvalidate || !shortcutState.details,
    details: shortcutState.details,
    error: shortcutState.error,
    location: location,
    preference: state.shortcuts.preference
  }

  return {
    isAdmin,
    shortcut
  }
}

function mapDispatchToProps (dispatch, props) {
  const shortcutId = props.match.params.shortcutId
  const accessToken = `DL:${shortcutId}`
  return {
    fetchShortcut: () => dispatch(fetchShortcutIfNeeded(shortcutId)),
    setPreference: (type) => dispatch(setShortcutAudiencePreference(shortcutId, type)),
    setAuth: () => dispatch(setOverrideAccessToken(accessToken))
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(ShortcutContainer)
